import { ApolloClient, InMemoryCache, HttpLink } from "@apollo/client";
import { FieldPolicy, FieldReadFunction } from "@apollo/client";
import { KeySpecifier } from "@apollo/client/cache/inmemory/policies";

// @ts-ignore
const backendUrl = import.meta.env.VITE_BACKEND_URL;

const offsetLimitPagination = (
  keyArgs: KeySpecifier | false = false,
  dataKey = "data"
): FieldPolicy<any> | FieldReadFunction<any> => {
  return {
    keyArgs,
    merge(existing, incoming, { variables, args }) {
      //@ts-ignore
      const { ignoreMerge = false } = variables;
      if (ignoreMerge) return incoming;
      const offset =
        //@ts-ignore
        ((args?.pagination?.page || variables?.page) - 1) *
          (args?.pagination?.limit || variables?.limit) || 0;
      const merged = existing ? existing[dataKey].slice(0) : [];
      for (let i = 0; i < incoming[dataKey].length; i++) {
        merged[offset + i] = incoming[dataKey][i];
      }
      return { ...incoming, [dataKey]: merged };
    },
  };
};

const cursorLimitUniquePagination = (
  keyArgs: KeySpecifier | false = false
): FieldPolicy<any> | FieldReadFunction<any> => {
  return {
    keyArgs,
    merge(existing, incoming, { readField, variables }) {
      //@ts-ignore
      const { ignoreMerge = false } = variables;
      if (ignoreMerge) return incoming;
      const merged = existing ? { ...existing.data } : {};
      // @ts-ignore
      (incoming.data || []).forEach((item) => {
        // @ts-ignore
        merged[readField("id", item)] = item;
      });
      return { ...incoming, data: merged };
    },
    read(existing) {
      return (
        existing && {
          ...existing,
          ...(existing.data && { data: Object.values(existing.data) }),
        }
      );
    },
  };
};

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getPublicProjects: cursorLimitUniquePagination([]),
      },
    },
    Project: {
      fields: {
        poles: {
          merge(existing = [], incoming) {
            return incoming;
          },
        },
        lashings: {
          merge(existing = [], incoming) {
            return incoming;
          },
        },
        bipodLashings: {
          merge(existing = [], incoming) {
            return incoming;
          },
        },
        tripodLashings: {
          merge(existing = [], incoming) {
            return incoming;
          },
        },
        scaffoldLashings: {
          merge(existing = [], incoming) {
            return incoming;
          },
        },
      },
    },
    Poleset: {
      fields: {
        poles: {
          merge(existing = [], incoming = []) {
            return incoming;
          },
        },
      },
    },
  },
});

const client = new ApolloClient({
  link: new HttpLink({
    uri: backendUrl,
    credentials: "include",
  }),
  cache,
});

export default client;
